import React, { useEffect } from "react";
import info from "./modaInfo.json";
const Modal = ({ setModal, modal, setImg_modal, setIsChanging, isChanging, setPreviewImgs }) => {
  const handleChange = (e) => {
    const file = e.target.files[0];
    setPreviewImgs(URL.createObjectURL(file));
    setImg_modal(file);
    setModal(!modal);
    setIsChanging(!isChanging);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="modal">
      <div className="containerAll">
        <h5 onClick={() => setModal(!modal)} className="x">
          x
        </h5>
        <h1 className="title">SELECCIONAR ARCHIVO</h1>
        <p>Puedes seleccionar entre las siguientes imágenes o subir tus propias fotos.</p>

        <input onChange={handleChange} type="file" accept="image/*" id="img" hidden />

        <div className="upload_file">
          <label htmlFor="img">
            Subir archivo
            <img loading="lazy" src="/assets/subir_rosado.png" alt="" />
          </label>
        </div>

        <div className="imgs_galery">
          {info.map((item, i) => (
            <div key={i}>
              <img
                onClick={() => {
                  setImg_modal(item.img);
                  setModal(!modal);
                  setIsChanging(!isChanging);
                }}
                src={item.img}
                alt=""
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Modal;
